/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading, camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composer
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { withDynamicImport } from '@thd-nucleus/app-render';
import { Skeleton, SkeletonBlock, SkeletonLine } from '@one-thd/sui-atomic-components';
import { useHydratedProps, withLayout, withLayoutAccordion, mergeProductClientOnlyProduct }
from '@thd-olt-component-react/fusion-utils';

import { RulesMiddleware as RulesMiddleware_MiddlewareSlot
  , withMagicApronTNT } from '@thd-olt-component-middleware/pip';

import { ProductOverviewAccordionTitle as ProductOverviewAccordionTitleG4Index0K0Header }
from '@thd-olt-component-react/product-overview';

import { SpecificationsAccordionTitle as SpecificationsAccordionTitleG4Index1K0Header }
from '@thd-olt-component-react/specifications';

import { QuestionsAndAnswersAccordionTitle as QuestionsAndAnswersAccordionTitleG4Index2K0Header }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle as RatingsAndReviewsAccordionTitleG4Index3K0Header }
from '@thd-olt-component-react/ratings-and-reviews';

const lazySlots = {};
const getPlaceholder = ({ skip }) => {
  if (skip) return null;
  return (
    <Skeleton>
      <SkeletonBlock />
      <SkeletonLine />
    </Skeleton>
  );
};

const SlotG3Placeholder0 = null;

const SlotG3Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "botprompt" */
    '@thd-olt-component-react/magic-apron');
};

export const SlotG3Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
      .BotPrompt;
  },
  client: SlotG3Index0Client,
  placeholder: SlotG3Placeholder0 || getPlaceholder({ skip: true }),
  name: 'BotPrompt',
});

let RulesMiddleware_MiddlewareSlot_G3 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_G3 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_G3, { render: { name: 'fs-prop:magic-apron-qa-bot-render-placement', value: 'above-accordion' } });

lazySlots.LazyBotPromptG3 = withLayout(

  [

    SlotG3Index0Load,

  ],

  RulesMiddleware_MiddlewareSlot_G3
  ,

  [

    {
      waitForComponent: SlotG3Index0Client,
      placeholder: SlotG3Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotG4Placeholder0K0 = null;

const SlotG4Index0ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/product-overview');
};

export const SlotG4Index0LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
      .ProductOverviewAccordionBody;
  },
  client: SlotG4Index0ClientK0,
  placeholder: SlotG4Placeholder0K0 || getPlaceholder({ skip: true }),
  name: 'ProductOverviewAccordionBody',
});

lazySlots.LazyProductOverviewAccordionBodyG4 = withLayout(
  SlotG4Index0LoadK0,

  null
  ,
  {
    waitForComponent: SlotG4Index0ClientK0,
    placeholder: SlotG4Placeholder0K0 || getPlaceholder({ skip: true })
  }
);

const SlotG4Placeholder1K0 = null;

const SlotG4Index1ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/specifications');
};

export const SlotG4Index1LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
      .SpecificationsWithKPFAccordionBody;
  },
  client: SlotG4Index1ClientK0,
  placeholder: SlotG4Placeholder1K0 || getPlaceholder({ skip: true }),
  name: 'SpecificationsWithKPFAccordionBody',
});

lazySlots.LazySpecificationsWithKPFAccordionBodyG4 = withLayout(
  SlotG4Index1LoadK0,

  null
  ,
  {
    waitForComponent: SlotG4Index1ClientK0,
    placeholder: SlotG4Placeholder1K0 || getPlaceholder({ skip: true })
  }
);

const SlotG4Placeholder2K0 = null;

const SlotG4Index2ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/questions-and-answers');
};

export const SlotG4Index2LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
      .QuestionsAndAnswersAccordionBody;
  },
  client: SlotG4Index2ClientK0,
  placeholder: SlotG4Placeholder2K0 || getPlaceholder({ skip: true }),
  name: 'QuestionsAndAnswersAccordionBody',
});

lazySlots.LazyQuestionsAndAnswersAccordionBodyG4 = withLayout(
  SlotG4Index2LoadK0,

  null
  ,
  {
    waitForComponent: SlotG4Index2ClientK0,
    placeholder: SlotG4Placeholder2K0 || getPlaceholder({ skip: true })
  }
);

const SlotG4Placeholder3K0 = null;

const SlotG4Index3ClientK0 = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "productoverviewaccordiontitle" */
    '@thd-olt-component-react/ratings-and-reviews');
};

export const SlotG4Index3LoadK0 = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
      .RatingsAndReviewsAccordionBody;
  },
  client: SlotG4Index3ClientK0,
  placeholder: SlotG4Placeholder3K0 || getPlaceholder({ skip: true }),
  name: 'RatingsAndReviewsAccordionBody',
});

lazySlots.LazyRatingsAndReviewsAccordionBodyG4 = withLayout(
  SlotG4Index3LoadK0,

  null
  ,
  {
    waitForComponent: SlotG4Index3ClientK0,
    placeholder: SlotG4Placeholder3K0 || getPlaceholder({ skip: true })
  }
);

const LazyG4Accordion = withLayoutAccordion([
  [

    [

      withLayout(
        ProductOverviewAccordionTitleG4Index0K0Header,

      ),

    ],

    [

      withLayout(
        SpecificationsAccordionTitleG4Index1K0Header,

      ),

    ],

    [

      withLayout(
        QuestionsAndAnswersAccordionTitleG4Index2K0Header,

      ),

    ],

    [

      withLayout(
        RatingsAndReviewsAccordionTitleG4Index3K0Header,

      ),

    ],

  ],
  [

    [

      lazySlots.LazyProductOverviewAccordionBodyG4,

    ],

    [

      lazySlots.LazySpecificationsWithKPFAccordionBodyG4,

    ],

    [

      lazySlots.LazyQuestionsAndAnswersAccordionBodyG4,

    ],

    [

      lazySlots.LazyRatingsAndReviewsAccordionBodyG4,

    ],

  ]
],

null
);

const SlotG5Placeholder0 = null;

const SlotG5Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "botprompt" */
    '@thd-olt-component-react/magic-apron');
};

export const SlotG5Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
      .BotPrompt;
  },
  client: SlotG5Index0Client,
  placeholder: SlotG5Placeholder0 || getPlaceholder({ skip: true }),
  name: 'BotPrompt',
});

let RulesMiddleware_MiddlewareSlot_G5 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_G5 = withMagicApronTNT(RulesMiddleware_MiddlewareSlot_G5, { render: { name: 'fs-prop:magic-apron-qa-bot-render-placement', value: 'default', default: true } });

lazySlots.LazyBotPromptG5 = withLayout(

  [

    SlotG5Index0Load,

  ],

  RulesMiddleware_MiddlewareSlot_G5
  ,

  [

    {
      waitForComponent: SlotG5Index0Client,
      placeholder: SlotG5Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

const SlotG7Placeholder0 = null;

const SlotG7Index0Client = () => {
  return import(
    /* webpackPrefetch: true, webpackChunkName: "roomvoinspire" */
    '@thd-olt-component-react/augmented-reality');
};

export const SlotG7Index0Load = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('@thd-olt-component-react/augmented-reality'))
      .RoomVoInspire;
  },
  client: SlotG7Index0Client,
  placeholder: SlotG7Placeholder0 || getPlaceholder({ skip: true }),
  name: 'RoomVoInspire',
});

lazySlots.LazyRoomVoInspireG7 = withLayout(

  [

    SlotG7Index0Load,

  ],

  null
  ,

  [

    {
      waitForComponent: SlotG7Index0Client,
      placeholder: SlotG7Placeholder0 || getPlaceholder({ skip: true })
    },

  ]
);

// to be generated by ejs based on config
export const DynamicImporter = (props) => {
  const { storeId, storeZip } = useStore();
  const slot = props.config.slots[props.slot];
  const components = slot.isAccordion
    ? slot.components.flat().map((sc) => sc.components).flat()
    : slot.components.flat();

  // todo use merge option?
  const hydratedProps = useHydratedProps(components, { itemId: props.itemId });
  components.forEach((com, index) => {
    // eslint-disable-next-line no-param-reassign
    com.props = hydratedProps[index];
  });

  const merge = mergeProductClientOnlyProduct;

  // use this for debugging, attache to queryProvider prop

  // const queryOptions = ({ options, queryName }) => {
  //   return {
  //     ...options,
  //     fetchPolicy: 'cache-only'
  //   };
  // };

  if (props.slot === 'slotG3') {

    return (
      <lazySlots.LazyBotPromptG3
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotG3"
        fusionComponentName="@thd-olt-component-react/magic-apron"
        version="3.1.1"
      />
    );

  }

  if (props.slot === 'slotG4') {

    return (
      <LazyG4Accordion
        {...props}
        config={props.config}
        fusionSlotName="slotG4"
        fusionComponentName="accordion"
        fusionClassName={slot.fusionClassName}
        isDynamic
        // commenting inner query provider since withDynamicImport already wraps AccordionBody with inner query provider
        // queryProvider={{
        //   inherit: 'page',
        //   merge,
        //   queryOptions,
        //   cache key for all accordions must be the same
        //   otherwise a race condition will occur generating duplicate requests
        //   cacheKey: 'page',
        //   defaultVariables: props?.qctx?.defaultVariables?.current || { storeId, zipCode: storeZip }
        // }}
      />
    );

  }

  if (props.slot === 'slotG5') {

    return (
      <lazySlots.LazyBotPromptG5
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotG5"
        fusionComponentName="@thd-olt-component-react/magic-apron"
        version="3.1.1"
      />
    );

  }

  if (props.slot === 'slotG7') {

    return (
      <lazySlots.LazyRoomVoInspireG7
        {...props}
        {...hydratedProps[0]}
        config={props.config}
        fusionSlotName="slotG7"
        fusionComponentName="@thd-olt-component-react/augmented-reality"
        version="7.3.0"
      />
    );

  }

  return null;
};

DynamicImporter.propTypes = {
  config: PropTypes.shape({
    slots: PropTypes.shape({})
  }).isRequired,
  slot: PropTypes.string.isRequired,
};
